import { useContext } from 'react';
import { ConfigContext } from '../../../../../context';
import { ChartType } from '../../Analytics';

export const useChartExclude = (chartType: ChartType) => {
  const { chartsExclude } = useContext(ConfigContext).config.elements.analytics;

  return chartsExclude.includes(chartType);
};
